export const SET_DATA = "SET_DATA";

export const SET_TABLE_INPUTS = "SET_TABLE_INPUTS";
export const SET_HIGHLIGHTED_COLS = "SET_HIGHLIGHTED_COLS";
export const SET_HIGHLIGHTED_ROWS = "SET_HIGHLIGHTED_ROWS";
export const SET_EMPTY_FORECAST = "SET_EMPTY_FORECAST";
export const SET_FORECASTED_STOCKPILE = "SET_FORECASTED_STOCKPILE";
export const SET_FORECAST_ID = "SET_FORECAST_ID";
export const SET_ACTIVE_FORECAST = "SET_ACTIVE_FORECAST";
export const SET_FILTERED_HIGHLIGHTED_STOCKPILES =
  "SET_FILTERED_HIGHLIGHTED_STOCKPILES";
export const SET_USER_INPUT_DATA = "SET_USER_INPUT_DATA";
